import { createReducer, on } from "@ngrx/store";
import { EAuthorizationActions } from "../actions";

export const submitEmailKey = 'email'

export interface State {
    isEmailSubmitCallFinished: boolean;
    isEmailSubmitted: boolean;
    hasSendEmailError: boolean; //represents failed call to DM to send Alliance instructions
    customerId: string;
}

export const initialSubmitEmailState: State = {
    isEmailSubmitCallFinished: false,
    isEmailSubmitted: false,
    hasSendEmailError: false,
    customerId: ''
}

export const submitEmailReducer = createReducer(
    initialSubmitEmailState,
    on(EAuthorizationActions.submitEmailSuccess, (state, action) => {
        return {
            ...state,
            isEmailSubmitCallFinished: true,
            isEmailSubmitted: true,
            hasSendEmailError: false,
            customerId: action.customerId
        }
    }),
    on(EAuthorizationActions.submitEmailFailure, (state, err) => {
        return {
            ...state,
            isEmailSubmitCallFinished: true,
            isEmailSubmitted: false,
            hasSendEmailError: err.errorMsg ? Object.values(err.errorMsg).includes('Failed call to send customer email') : false
        }
    }),
    on(EAuthorizationActions.submitEmailFailureNullResponse, (state) => {
        return {
            ...state,
            isEmailSubmitCallFinished: true,
            isEmailSubmitted: false
        }
    })
);